import { render, staticRenderFns } from "./yeji.vue?vue&type=template&id=2f704b10"
import script from "./yeji.vue?vue&type=script&lang=js"
export * from "./yeji.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports